module.exports = __webpack_public_path__ + "img/unitsTitle.3480a1b4.png";